export default function Pagination(props) {
  const {
    totalPages,
    currentPage,
    setCurrentPage
  } = props

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle page number click
  const handlePageClick = (page) => {
    setCurrentPage(page);
  };
  const generatePageNumbers = () => {
    let pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };
  return (
    <div className="pagination">
      <div className="flex items-center justify-center space-x-1 mt-6">
        <button
          onClick={handlePrevious}
          disabled={currentPage === 1}
          className={`px-3 py-2 rounded-md border ${currentPage === 1
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "hover:bg-gray-100"
            }`}
        >
          Previous
        </button>

        {generatePageNumbers().map((page) => (
          <button
            key={page}
            onClick={() => handlePageClick(page)}
            className={`border px-3 py-2 rounded-md ${page === currentPage ? "bg-[#f4a406] text-white" : "hover:bg-gray-100"
              }`}
          >
            {page}
          </button>
        ))}
        {/* <span className="px-3 py-2 text-gray-500">...</span>
        <button className="border px-3 py-2 rounded-md hover:bg-gray-100">10</button> */}

        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className={`px-3 py-2 rounded-md border ${currentPage === totalPages
            ? "bg-gray-200 text-gray-400 cursor-not-allowed"
            : "hover:bg-gray-100"
            }`}
        >
          Next
        </button>
      </div>
    </div>
  );
}